import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {FormService} from '../../../services/formServices';
import {Sort} from '../../../domain/sort/sort';
import {Usuario} from '../../../domain/usuario';
import { ModalOptions, ModalDirective } from 'angular-bootstrap-md';

@Component({
  selector: 'app-select-executor',
  templateUrl: './select-executor.component.html',
  styleUrls: ['./select-executor.component.scss']
})
export class SelectExecutorComponent implements OnInit {

    @Input('id')id: number;
    @Input('selected')selected: number;
    @Input('state')state: string;
    @Output('actualizar')actualizar = new EventEmitter<boolean>();
    sort: Sort;
    main: Array<Usuario>;
    data: any;
    asigned: Boolean;
    usuario: Usuario;
    @ViewChild('demoBasic') demoBasic: ModalDirective;
    modalConfigDefaults: ModalOptions = {
        backdrop: false,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: false,
        class: '',
        animated: true
      };
    constructor(private formService: FormService, private toastr: ToastrService) {
    }

    ngOnInit(): void {
        this.demoBasic.config = this.modalConfigDefaults;
        this.usuario = {id:0,name:'...',email:'...'}
        this.data = { 'id': this.id, 'idEjecutor': this.selected};
        if (this.selected) {
            this.asigned = true;
        } else {
            this.selected = 0;
        }
        this.refreshCombo();
    }
    onChange() {
            this.updateUser();
            this.data = { 'id': this.id, 'idEjecutor': this.selected};
            if(this.selected > 0 ){
                this.asignarEjecutor();
            }else {
                this.toastr.error('Debe seleccionar un ejecutor', 'error');
            }
    }
    actualizarVista(bool) {
        this.refreshCombo();
        this.cerrarVentana();
        bool = this.state === 'finalizados' ? false : bool;
        this.actualizar.emit(bool);
    }
    cerrarVentana(){
        this.demoBasic.hide();
    }
    updateUser(){
        this.usuario = this.main.find(data => data.id === this.selected )
    }
    asignarEjecutor(){
        this.formService.asignarEjecutor(this.data).subscribe(
            datax => {
                this.toastr.success('Ejecutor Asignado!', 'Exito');
                this.asigned = true;
                this.actualizarVista(true);
            },
            error => this.toastr.error('Ha ocurrido un error en la actualización!', 'error')
        );
    }
    desasignarEjecutor(){
        this.formService.DesasignarEjecutor(this.data).subscribe(
            datax => {
                this.toastr.success('Ejecutor Desasignado!', 'Exito');
                this.asigned = false;
                this.usuario.id = 0;
                this.selected = 0;
                this.actualizarVista(true);
            },
            error => this.toastr.error('Ha ocurrido un error en la actualización!', 'error')
        );
    }
    refreshCombo(){
        this.formService.getExecutors().subscribe(
            data => {
                this.main = data;
                this.updateUser();
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/modals/select-executor/select-executor.component.ts